import Vue from 'vue';
import { getMemberList } from '../../../services/personnelService/contactsService';
import { getTiffanyMemberLevelAndGender } from '../../../services/custom/tiffany/tiffanyService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  memberList: [],
  pagination: {
    current_page: 0,
    per_page: 5
  },
  tiffanyLevel: [],
  tiffanyRole: [],
  tiffanyGender: []
};

// getters
const getters = {};

// actions
const actions = {
  // 取得CA Profile
  async getMemberListHandler({ commit }, paginationInfo) {
    const data = await getMemberList(paginationInfo);
    commit('setMemberList', data);
  },
  // 取得 Tiffany 的會員等級&性別
  async getTiffanyMemberLevelAndGenderHandler({ commit }) {
    const data = await getTiffanyMemberLevelAndGender();
    commit('setMemberLevelAndGender', data);
  }
};

// mutations
const mutations = {
  setMemberList(state, data) {
    Vue.set(state, 'memberList', state.memberList.concat(data.data.members));
    Vue.set(state, 'pagination', data.pagination);
  },
  resetHandler(state) {
    Vue.set(state, 'memberList', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 5
    });
  },
  setMemberLevelAndGender(state, data) {
    Vue.set(state, 'tiffanyLevel', data.data.level);
    Vue.set(state, 'tiffanyGender', data.data.gender);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
